/**
 * Concatenat individual strings using the supplied separator.
 *
 * @param separator The string used two separate each part.
 * @param strings The strings which should be concatenated. Every falsy value like `""`, `0`, `false`, `undefined` or `null` will be skipped.
 */
export function concat(separator: string, ...strings: Array<string | number | false | undefined | null>): string {
    return strings.filter((x) => x).join(separator)
}
